import React from 'react'
import AppealTable from './AppealTable'

function Pending({filterIntake,globalReset,filterLearningMethod,filterSchool,filterLecturer}) {
  return <AppealTable filterIntake={filterIntake} globalReset={globalReset} filterLearningMethod={filterLearningMethod} filterSchool={filterSchool} filterLecturer={filterLecturer}/>
}

export default Pending